<template>
  <div v-show="pageCount > 1" class="rfp-mctb-carousel-pagination">
    <div class="rfp-mctb-carousel-dot-container">
      <div
        v-for="(page, index) in pageCount"
        :key="page"
        class="rfp-mctb-carousel-dot"
        :class="{ 'rfp-mctb-carousel-dot--active': index === currentPage }"
        :style="`
          margin-top: ${paginationPadding * 2}px;
          padding: ${paginationPadding}px;
        `"
        @click="goToPage(index)"
      >
        <div
          class="rfp-mctb-carousel-dot-inner"
          :style="`
            width: ${paginationSize}px;
            height: ${paginationSize}px;
            background: ${index === currentPage ? paginationActiveColor : paginationColor};
          `"
        ></div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'rfp-mctb-pagination',
  props: {
    pageCount: {
      type: Number,
      required: true,
    },
    currentPage: {
      type: Number,
      required: true,
    },
    paginationPadding: {
      type: Number,
      required: true,
    },
    paginationSize: {
      type: Number,
      required: true,
    },
    paginationActiveColor: {
      type: String,
      required: true,
    },
    paginationColor: {
      type: String,
      required: true,
    },
  },
};
</script>
